/*
  ** MasterPage.jsx **
  Elemento que coloca o Menu e o Footer em todas as páginas.
  Dentro do <Helmet> define o formato do <title> para todas as páginas.
*/

import React, { Suspense } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import Menu from "./new-home/Menu"

const Footer = React.lazy(() => import('./Footer'));
const FooterHome = React.lazy(() => import('./home/FooterHome'));

function MasterPage({ children, noindex, namePage }) {
  return (
    <>
      <Helmet titleTemplate="%s | UOL Play" defaultTitle="Assista a filmes, séries e esportes online | UOL Play">
        <meta name="robots" content={noindex ? "noindex,nofollow" : "index,follow"} />
      </Helmet>

      {children && children}
      <Menu />
      <Suspense fallback={<h3>Carregando...</h3>}>
        <FooterHome />
      </Suspense>

    </>
  );
}

MasterPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MasterPage;
